export enum WayToPay {
  CASH = 1,
  DATAPHONE = 2,
  ONLINE = 3,
  CASH_ROUND_TRIP = 4,
}
